var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingCardReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#080A09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8369 17.9585C16.6331 18.0429 16.3985 17.9962 16.2425 17.8402L15.0855 16.6832L13.9284 17.8402C13.8261 17.9425 13.6874 18 13.5427 18C13.398 18 13.2593 17.9425 13.157 17.8402L11.9999 16.6831L10.8428 17.8402C10.7405 17.9425 10.6018 18 10.4571 18C10.3125 18 10.1738 17.9425 10.0714 17.8402L8.91438 16.6831L7.75733 17.8402C7.6013 17.9962 7.36664 18.0429 7.1629 17.9585C6.95908 17.874 6.82617 17.6751 6.82617 17.4545V6.54548C6.82617 6.24424 7.07039 6.00003 7.37162 6.00003H16.6282C16.9295 6.00003 17.1737 6.24424 17.1737 6.54548V17.4545C17.1737 17.6751 17.0408 17.874 16.8369 17.9585ZM16.0828 7.0909H7.91708V16.1377L8.52868 15.5261C8.631 15.4238 8.76969 15.3663 8.91438 15.3663C9.05907 15.3663 9.19776 15.4238 9.30009 15.5261L10.4571 16.6831L11.6142 15.526C11.8272 15.3131 12.1726 15.3131 12.3856 15.526L13.5427 16.6831L14.6997 15.5261C14.802 15.4238 14.9408 15.3663 15.0855 15.3663C15.2301 15.3663 15.3689 15.4238 15.4712 15.5261L16.0828 16.1377V7.0909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4465 9.63623H9.55351C9.25227 9.63623 9.00806 9.39201 9.00806 9.09078C9.00806 8.78954 9.25227 8.54532 9.55351 8.54532H14.4465C14.7477 8.54532 14.9919 8.78954 14.9919 9.09078C14.9919 9.39201 14.7477 9.63623 14.4465 9.63623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55351 10.7275H12.2647C12.5659 10.7275 12.8101 10.9717 12.8101 11.2729C12.8101 11.5741 12.5659 11.8184 12.2647 11.8184H9.55351C9.25227 11.8184 9.00806 11.5741 9.00806 11.2729C9.00806 10.9717 9.25227 10.7275 9.55351 10.7275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55351 12.9091H12.2647C12.5659 12.9091 12.8101 13.1533 12.8101 13.4545C12.8101 13.7558 12.5659 14 12.2647 14H9.55351C9.25227 14 9.00806 13.7558 9.00806 13.4545C9.00806 13.1533 9.25227 12.9091 9.55351 12.9091Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "matrix(1 0 0 -1 6 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingCardReceiptIcon);
export default __webpack_public_path__ + "static/media/booking-card-receipt-icon.7cba3a9b62ab75799c4801213b7428d1.svg";
export { ForwardRef as ReactComponent };